import cn from "classnames";
import type React from "react";
import { useDrop } from "react-dnd";
import { HiBadgeCheck } from "react-icons/hi";
import { VscError } from "react-icons/vsc";
import style from "./DroppableElement.module.scss";

type DroppableProps = {
	card: {
		word: string;
		imageUrl: string;
		currentIndex: number;
		originalIndex: number;
		correct: boolean | undefined;
	};
	index: number;
	onDropWord: (
		card: { card: { word: string; index: number; id: string } },
		index: number,
	) => void;
	onWordClick: (
		word: string,
		currentIndex: number,
		originalIndex: number,
	) => void;
};

export const DroppableElement: React.FC<DroppableProps> = ({
	card,
	index,
	onDropWord,
	onWordClick,
}) => {
	const [{ isOver }, drop] = useDrop({
		accept: "matchWordWithPic",
		drop: (card: { card: { word: string; index: number; id: string } }) => {
			onDropWord(card, index);
		},
		canDrop: () => !card.word,
		collect: (monitor) => ({
			isOver: !!monitor.isOver(),
		}),
	});

	return (
		<div
			className={cn(style.card, {
				[style["card--over"]]: isOver,
				[style["card--not-over"]]: !isOver,
			})}
			ref={drop}
		>
			<img alt="card" src={card.imageUrl} />
			<div
				className={cn(style.wordPlaceholder, {
					[style["wordPlaceholder--correct"]]: card.correct,
					[style["wordPlaceholder--incorrect"]]: card.correct === false,
				})}
				onClick={
					card.word
						? () =>
								onWordClick(card.word, card.currentIndex, card.originalIndex)
						: () => {}
				}
				onKeyUp={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						card.word &&
							onWordClick(card.word, card.currentIndex, card.originalIndex);
					}
				}}
			>
				{card.word ?? ""}
				{card.correct && card.correct !== undefined && (
					<HiBadgeCheck
						className={cn(style.icon, {
							[style["wordPlaceholder--correct-icon"]]: card.correct,
						})}
					/>
				)}
				{!card.correct && card.correct !== undefined && (
					<VscError
						className={cn(style.icon, {
							[style["wordPlaceholder--incorrect-icon"]]: !card.correct,
						})}
					/>
				)}
			</div>
		</div>
	);
};
